<template>
    <div id="activePhoneCalls">
        <CallItem class="ma-4" v-for="call in activeCalls" :key="call.reference" :call="call" />
    </div>
</template>

<script>
import {values} from "lodash";
import ActivePhoneCall from "@/models/PhoneCall/ActivePhoneCall";
import CallItem from "@/components/PhoneCall/Active/CallItem";

export default {
    components: {
        CallItem
    },
    sockets: {
        disconnect() {
            ActivePhoneCall.deleteAll();
        },
        'call:pushed'(val) {
            ActivePhoneCall.insertOrUpdate({
                data: val
            });
        },
        'phone-call:created'(val) {
            ActivePhoneCall.update({
                where: (call) => {
                    return call.reference === val.reference
                },
                data: {
                    phone_call_id: val.id,
                }
            });
        },
        'call:ended'(val) {
            ActivePhoneCall.update({
                where: (call) => {
                    return call.reference === val.reference
                },
                data: {
                    end_time: val.end_time
                }
            });

            if (!val.is_sticky) {
                ActivePhoneCall.query().find(val.reference).$delete();
            }
        },
        'user:calls'(activeCalls) {
            ActivePhoneCall.insert({
                data: values(activeCalls),
            });
        },
        'call:updated'(val) {
            const call = ActivePhoneCall.query().find(val.reference);
            if (call) {
                call.$update(val);
            }
        },
        'call:deleted'(val) {
            const call = ActivePhoneCall.query().find(val.reference);
            if (call) {
                call.$delete();
            }
        },
    },
    computed: {
        activeCalls() {
            return ActivePhoneCall.query().all();
        }
    },
}
</script>
